import React from 'react'
import { Box } from '@moonpig/launchpad-components'
import { useProductStore } from '../../../contexts/product'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { getCardVariantName } from './utils/getCardVariantName'
import { getDimensions } from './utils/getDimensions'
import { CardScenePreview } from './components/CardScenePreview'
import { CardSize } from './utils/types'
import {
  checkFavourited,
  useFavouritesState,
} from '../../../contexts/favourites'
import { useHandleFavourite } from '../../../utils/favourites'
import { PageTypeEnum } from '../../../types'
import { FavouriteButtonProps } from './components/FavouriteButton'
import { getCardOrientation } from './utils/getCardOrientation'
import { getCardImageUrl } from './utils/getCardImageUrl'
import { E_CARD_SIZE_ID, POSTCARD_SIZE_ID } from '../../../constants'
import { MoreLikeThisButton } from '../../../components/MoreLikeThisButton/MoreLikeThisButton'

export const SimplifiedProductImageModule = () => {
  const [{ product, variant }] = useProductStore()

  const { favourites } = useFavouritesState()
  const handleFavourite = useHandleFavourite({
    tracking: {
      totalCount: 1,
      pageLocation: PageTypeEnum.ADD_A_CARD,
    },
    removeWithConfirmation: false,
  })
  const isSelected = checkFavourited(favourites, product)

  const favourite: FavouriteButtonProps = {
    isSelected,
    onSelect: () => handleFavourite(product, isSelected, 0),
  }

  const isDynamicImagesEnabled = useExperiment('search-use-dynamic-images', {
    fallback: false,
  })

  const imageUrl = getCardImageUrl({
    isDynamicImagesEnabled,
    product,
  })
  const standardVariant = product.variants
    .map(listVariant => {
      return {
        name: getCardVariantName(listVariant.key),
        title: listVariant.title,
        dimensions: getDimensions(listVariant.dimensions),
        sku: listVariant.sku,
        key: listVariant.key,
      }
    })
    .filter(({ name }) => name === CardSize.Standard)[0]
  if (!standardVariant) throw new Error('No standard variant for the product!')

  const isLandscape = !!product.isLandscape
  const masterVariantKey = product.masterVariant.key

  const CardScenePreviewProps = {
    selectedVariant: standardVariant,
    cardOrientation: getCardOrientation({
      isLandscape,
      variantKey: masterVariantKey,
    }),
    coverImageUrl: imageUrl,
    favourite,
    isECard: variant.key === E_CARD_SIZE_ID,
    isPostcard: masterVariantKey === POSTCARD_SIZE_ID,
  }

  return (
    <Box data-testid="module-simplified-product-image" position="relative">
      <CardScenePreview {...CardScenePreviewProps} />
      <MoreLikeThisButton />
    </Box>
  )
}
